import { SetupConfiguration } from '@/types/setup';
import { saveSetupConfiguration } from '@/lib/SetupConfiguration';

export const saveSetupConfig = async (config: SetupConfiguration): Promise<SetupConfiguration> => {
  try {
    // Validate configuration before saving
    if (!config.apiKeys.openWeatherMapKey.trim()) {
      throw new Error('OpenWeatherMap API key is required');
    }
    
    if (!config.apiKeys.newsApiKey.trim()) {
      throw new Error('NewsAPI key is required');
    }
    
    if (!config.locationPermissionGranted) {
      throw new Error('Location permission is required');
    }

    // Mark setup as completed
    const completedConfig: SetupConfiguration = {
      ...config,
      setupCompleted: true
    };

    // Save to localStorage
    saveSetupConfiguration(completedConfig);

    // Return the saved configuration
    return completedConfig;
  } catch (error) {
    throw new Error(
      error instanceof Error 
        ? error.message 
        : 'Failed to save setup configuration'
    );
  }
};